import React from 'react';

const SvgProfilePassword = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <path d="M30.857 16.076h-2.732v-9a5.143 5.143 0 00-5.143-5.143h-9.964a5.142 5.142 0 00-5.143 5.143v9H5.143c-.711 0-1.286.575-1.286 1.286v15.429c0 .71.575 1.285 1.286 1.285h25.714c.712 0 1.286-.574 1.286-1.285V17.362c0-.711-.574-1.286-1.286-1.286zm-20.089-9a2.251 2.251 0 012.25-2.25h9.964a2.251 2.251 0 012.25 2.25v9H10.768v-9zM29.25 31.183H6.75V18.97h22.5v12.214zM16.875 25.6v2.13c0 .176.145.32.322.32h1.607a.322.322 0 00.321-.32V25.6a1.93 1.93 0 10-2.25 0z" />
  </svg>
);

export default SvgProfilePassword;
